import React, { Suspense } from "react";
import { LoadingSpinner } from "src/components/ui/loading-spinner";

const OpsgenieIntegration = React.lazy(() => import("./OpsgenieIntegration"));

interface OpsgenieIntegrationProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function OpsgenieIntegrationLazy(props: OpsgenieIntegrationProps) {
  return (
    <Suspense fallback={<div className="flex justify-center p-4"><LoadingSpinner /></div>}>
      <OpsgenieIntegration {...props} />
    </Suspense>
  );
}